import styled from "styled-components"

export const SignContent = styled.div`
    width: 640px;

    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: 1200px) {
        width: 620px;
    }

    @media screen and (max-width: 640px) {
        width: 100vw;
    }  
`

export const Content = styled.div.attrs({
    className: 'app-content'
})``

const OldContent = styled.div.attrs({
    className: 'app-content-o'
})``

OldContent.displayName = 'Content'

export default OldContent